// import axios from "axios";
import api from "./apiConfig";


export const getAllInvoices = async (page = 1, limit = 20) => {
  try {
    const res = await api.get("/invoices", {
      params: { page, limit },
      headers: { "x-auth-token": localStorage.getItem("token") },
    });

    return [null, res.data];
  } catch (error) {
    return [{ message: error.message }, null];
  }
};


export const getTotalRevenue = async (data) => {
  return await new Promise(async (resolve, reject) => {
    try {
      const invoicesCall = await api.get("/invoices/total-revenue", {
        params: data,
        headers: { "x-auth-token": localStorage.getItem("token") },
      });

      let status = invoicesCall?.data?.status;
      let successData = invoicesCall?.data?.data;
      let message = invoicesCall?.data.message;

      if (status !== 200) {
        resolve([{ message, status }, null]);
      } else {
        resolve([null, successData]);
      }
    } catch (error) {
      resolve([{ message: error, status: 500 }, null]);
    }
  });
};
export const getSingleInvoices = async (data) => {
  try {
    const invoicesCall = await api.get(`/invoices/${data.id}`);
    const { status, message, data: responseData } = invoicesCall.data;

    // If we have a successful response
    if (status === 200 && responseData) {
      return [null, responseData];
    }

    return [
      {
        message: message || "Failed to fetch invoice",
        status: status || 400,
      },
      null,
    ];
  } catch (error) {
    console.error("[Debug] API Call Error:", error);

    // Handle axios error response
    if (error.response?.data) {
      return [
        {
          message: error.response.data.message || "Error fetching invoice",
          status: error.response.data.status || 500,
        },
        null,
      ];
    }
    // Handle network or other errors
    return [
      {
        message: error.message || "Network error",
        status: 500,
      },
      null,
    ];
  }
};

export const createInvoice = async (data) => {
  return await new Promise(async (resolve, reject) => {
    try {
      const invoicesCall = await api.post("/invoices", data, {
        headers: { "x-auth-token": localStorage.getItem("token") },
      });

      const status = invoicesCall?.data?.status;
      const successData = invoicesCall?.data?.data;
      const message = invoicesCall?.data.message;

      if (status !== 200) {
        resolve([{ message, status }, null]);
      } else {
        resolve([null, successData]);
      }
    } catch (error) {
      reject(error);
    }
  });
};

export const updateInvoice = async (invoice) => {
  return await new Promise(async (resolve, reject) => {
    try {
      const invoiceId = invoice.id || invoice._id;
      const response = await api.put(
        `/invoices/${invoiceId}`,
        {
          ...invoice,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": localStorage.getItem("token"),
          },
        }
      );
      let status = response?.data?.status;
      let successData = response?.data?.data;
      let message = response?.data?.message;

      if (status !== 200) {
        resolve([{ message, status }, null]);
      } else {
        resolve([null, successData]);
      }
    } catch (error) {
      console.error("Error updating invoice:", error);
      throw error;
    }
  });
};

export const deleteInvoice = async (invoiceId) => {
  return await new Promise(async (resolve, reject) => {
    try {
      const response = await api.delete(`/invoices/${invoiceId}`, {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      });
      let status = response?.data?.status;
      let successData = response?.data?.data;
      let message = response?.data?.message;

      if (status !== 200) {
        resolve([{ message, status }, null]);
      } else {
        resolve([null, successData]);
      }
    } catch (error) {
      console.error("Error deleting invoice:", error);
      reject(error);
    }
  });
};

export const getTotalInvoices = async () => {
  try {
    const response = await api.get(`/invoices/total`, {
      headers: { "x-auth-token": localStorage.getItem("token") },
    });

    return response.data.message.total;
  } catch (error) {
    throw error;
  }
};

export const getInvoiceSummaryStats = async () => {
  try {
    const response = await api.get(`/invoices/summary-stats`, {
      headers: { "x-auth-token": localStorage.getItem("token") },
    });
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getMonthlyInvoiceCount = async () => {
  try {
    const response = await api.get("/invoices/monthly-count", {
      headers: { "x-auth-token": localStorage.getItem("token") },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error fetching monthly invoice count:", error);
    return [];
  }
};

export const getPaymentInvoice = async (reference) => {
  try {
    const response = await api.get(`/invoices/verify-payment/${reference}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching invoice verification:", error);
    throw error;
  }
};

export const updatePaymentStatus = async (invoice) => {
  try {
    const invoiceId = invoice.id || invoice._id;
    const response = await api.put(
      `/invoices/update-payment-status/${invoiceId}`,
      {},
      {
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        }
      }
    );
    return [null, response.data];
  } catch (error) {
    console.error("Error updating payment status:", error);
    return [
      {
        message:
          error.response?.data?.message || "Failed to update payment status",
      },
      null,
    ];
  }
};

export const sendPaymentLink = async (invoice) => {
  try {
    const invoiceId = invoice.id || invoice._id;

    const response = await api.post(
      `/invoices/send-payment-link/${invoiceId}`,
      {
        customer_email: invoice.customer_email,
        customer_phone: invoice.customer_phone,
        paymentType: invoice.paymentType,
        customer_country: invoice.customer_country,
        country_code: invoice.country_code,
      },
      {
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      }
    );

    console.log("Payment link:", response.data.paymentLink);
    return [null, response.data];
  } catch (error) {
    console.error("Error sending payment link:", error);
    return [
      {
        message:
          error.response?.data?.message || error.message || "Failed to send payment link",
        status: error.response?.status,
      },
      null,
    ];
  }
};

export const sendReceipt = async (invoice) => {
  try {
    const invoiceId = invoice.id || invoice._id;
    const response = await api.post(`/invoices/send-receipt/${invoiceId}`, {
      customer_email: invoice.customer_email,
    },
      {
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        }
      }

    );

    return [null, response.data];
  } catch (error) {
    console.error("Error sending payment receipt:", error);
    return [{ message: error.message, status: error.response?.status }, null];
  }
};

// pawaPay Aggregator
export const getPawaPayPayment = async (reference) => {
  try {
    const response = await api.get(
      `/invoices/getpawapay?invoiceId=${reference}`
    );
    // console.log(response);
    return response?.data;
  } catch (error) {
    console.error("Error fetching invoice verification:", error);
    throw error;
  }
};


export const convertCurrency = async (amount, fromCurrency, toCurrency) => {
  try {
    const response = await api.post('/invoices/convert', {
      amount,
      fromCurrency,
      toCurrency
    });
    return response.data;
  } catch (error) {
    console.error('Currency conversion error:', error);
    throw new Error('Failed to convert currency');
  }
};